import React from 'react';
import "../assete/css/footer.css";
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import foot_logo from "../assete/footer/footlogo-min.png";

const Footer = () => {
  const navigate = useNavigate();

  const phd_peoposal = (path) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };


  return (
    <>
      <div className='footer_main_div'>
        <div className='footer_div_1'>
          <div className='footer_div_2'>
            <img src={foot_logo} alt="Footer Logo" data-aos="fade-down" />
            <div className='fo_cont_1'>
              <p data-aos="fade-down" style={{ fontWeight: "100" }}>Welcome to Sea Sense Research, where we empower scholars with expert support and guidance. </p>
            </div>
            <div className='social_icons' data-aos="fade-down">
              <div className="tooltip">
                <a href="https://www.facebook.com/seasensesoftwares/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <span className="tooltiptext">Facebook</span>
              </div>
              <div className="tooltip">
                <a href="https://www.instagram.com/sea_sense_research?igsh=MWVnYTNxZ3Noc3A1bg==" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <span className="tooltiptext">Instagram</span>
              </div>
              <div className="tooltip">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
                <span className="tooltiptext">LinkedIn</span>
              </div>
              <div className="tooltip">
                <a href="https://wa.me/8526700700" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
                <span className="tooltiptext">WhatsApp</span>
              </div>
            </div>
          </div>
          <div className='foote_next_page'>
            <h2 data-aos="fade-down">EXPLORE <div className='underline'><span></span></div></h2>
            <p data-aos="fade-down"><Link to="/About" onClick={() => phd_peoposal("/About")} style={{ fontWeight: "100" }}>About</Link></p>
            <p data-aos="fade-down"><Link to="/Service" onClick={() => phd_peoposal("/Service")} style={{ fontWeight: "100" }}>Service</Link></p>
            <p data-aos="fade-down"><Link to="/Terms" onClick={() => phd_peoposal("/Terms")} style={{ fontWeight: "100" }}>Terms & Condition</Link></p>
            <p data-aos="fade-down"><Link to="/Privacy" onClick={() => phd_peoposal("/Privacy")} style={{ fontWeight: "100" }}>Privacy Policy</Link></p>
            <p data-aos="fade-down"><Link to="/Cancellationpolicy" onClick={() => phd_peoposal("/Cancellationpolicy")} style={{ fontWeight: "100" }}>Cancellation Policy</Link></p>
          </div>
          <div className='add_address_foot'>
            <div className='add_add_fo'>
              <h2 data-aos="fade-down">Head Office <div className='underliness'><span></span></div></h2>
              <h1 data-aos="fade-down">Sea Sense Interdisciplinary Research and IT Solutions (OPC) Pvt. Ltd.</h1>
              <p data-aos="fade-down" style={{ fontWeight: "100" }}>JJ Arcade, Second Floor</p>
              <p data-aos="fade-down" style={{ fontWeight: "100" }}>Near New Bus Stand</p>
              <p data-aos="fade-down" style={{ fontWeight: "100" }}>Marthandam, Kanyakumari District</p>
              <p data-aos="fade-down" style={{ fontWeight: "100" }}>Tamil Nadu, India - 629165</p>


            </div>
          </div>
          <div className='add_sub_addrs'>
            <h2 data-aos="fade-down">Our Branches <div className='underlines'><span></span></div></h2>

            <h1 data-aos="fade-down">Sea Sense Technologies</h1>
            <p data-aos="fade-down" style={{ fontWeight: "100" }}>Mullackal Rd, Erezha, Mullakkal</p>

            <p data-aos="fade-down" style={{ fontWeight: "100" }}>Alleppey, Kerala, India - 688001</p>
            <h1 data-aos="fade-down">Sea Sense Softwares</h1>
            <p data-aos="fade-down" style={{ fontWeight: "100" }}>3rd Floor, Almighty Towers</p>
            <p data-aos="fade-down" style={{ fontWeight: "100" }}>Near Vadasery Bus Stand, Nagercoil


            </p>
            <p data-aos="fade-down" style={{ fontWeight: "100" }}>Tamil Nadu, India - 629001


            </p>
          </div>
        </div>
        <div className='foot_copy_div_1'>
          <h2 style={{ fontWeight: "100" }}>Copyright © 2024 - 2025 SEA SENSE | All Rights Reserved</h2>
        </div>
      </div>

    </>
  )
}

export default Footer